import RegisterModalProvider from "@/components/home/RegisterModalProvider";
import ExchangeRateProvider from "@/components/home/ExchangeRateProvider";
import AnnouncementBar from "@/components/home/AnnouncementBar";
import Navbar from "@/components/home/Navbar";
import Hero from "@/components/home/Hero";
import SocialProof from "@/components/home/SocialProof";
import Benefits from "@/components/home/Benefits";
import YourRules from "@/components/home/YourRules";
import ComparisonTable from "@/components/home/ComparisonTable";
import HowItWorks from "@/components/home/HowItWorks";
import Pricing from "@/components/home/Pricing";
import SeasonalCampaigns from "@/components/home/SeasonalCampaigns";
import Testimonials from "@/components/home/Testimonials";
import CommissionCalculator from "@/components/home/CommissionCalculator";
import FAQ from "@/components/home/FAQ";
import FinalCTA from "@/components/home/FinalCTA";
import Footer from "@/components/home/Footer";
import FloatingWhatsApp from "@/components/home/FloatingWhatsApp";

export default function Home() {
  return (
    <ExchangeRateProvider>
      <RegisterModalProvider>
        <div className="home-page" data-testid="home-page">
          <AnnouncementBar />
          <Navbar />
          <main>
            <Hero />
            <SocialProof />
            <Benefits />
            <YourRules />
            <ComparisonTable />
            <HowItWorks />
            <Pricing />
            <CommissionCalculator />
            <SeasonalCampaigns />
            <Testimonials />
            <FAQ />
            <FinalCTA />
          </main>
          <Footer />
          <FloatingWhatsApp />
        </div>
      </RegisterModalProvider>
    </ExchangeRateProvider>
  );
}
